<div class="row p-5 ">
    <div class="col-sm-12 w-100">
        <div class="d-flex flex-column justify-content-between  row w-100 m-0">

  
 
                                               <!-- <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="https://appointele.com/assets/logo2020w.png" />-->

                                                    <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />

<div class="w-100 text-center">
    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate >COVID-19 SELF ASSESSMENT DECLARATION </h3>
</div>

<div class="border  bg-white "></div>
<div class="w-100 text-center">
    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate >I do not have any COVID-19 related symtoms and not have been in contact with anyone with COVID-19 related symtoms. </h4>
</div>

<!--<div class="w-100 text-center">
    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" >I have not traveled outside of Country in the last 14 days. </h4>
</div>-->



<div class="pt-5" style="display: block; margin-right: auto; margin-left: auto; " >
    <h1 class="text-dark  mt-5 p-3 px-5 bg-white" style="font-family:'DINPro'; font-weight: bold; "><a class="text-dark " routerLink="/main-menu" translate>I AGREE</a></h1>
</div>
<div class="pb-5 " style="display: block; margin-right: auto; margin-left: auto; " >
    <h1 class="text-dark  mb-5 p-3 bg-white" style="font-family:'DINPro'; font-weight: bold; "><a class="text-dark " routerLink="/main-menu" translate>I DO NOT AGREE</a></h1>
</div>
    </div>
</div>
</div>
